import { render, staticRenderFns } from "./sum.vue?vue&type=template&id=0567a118"
import script from "./sum.vue?vue&type=script&lang=js"
export * from "./sum.vue?vue&type=script&lang=js"
import style0 from "./sum.vue?vue&type=style&index=0&id=0567a118&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports